module.exports = __webpack_public_path__ + "img/placeholder.5d7b71b2.png";